const float = {
  state: {
    floatzIndex:9999,
    floatList:[]
  },
  mutations: {
    addzIndex: (state) => {
      state.floatzIndex++
    },
    addFloatList:(state,item) => {
      item.id = "float"+new Date().getTime()
      item.miniSize = false
      state.floatList.push(item)
    },
    deleteFloatList:(state,id) => {
      const index = state.floatList.findIndex(item => item.id === id)
      state.floatList.splice(index,1)
    },
    minusFloadList:(state, id) => {
      const index = state.floatList.findIndex(item => item.id === id)
      const data = JSON.parse(JSON.stringify(state.floatList[index]))
      data.miniSize = true
      state.floatList.splice(index,1, data)
    },
    maximFloadList:(state, id) => {
      const index = state.floatList.findIndex(item => item.id === id)
      const data = JSON.parse(JSON.stringify(state.floatList[index]))
      data.miniSize = false
      state.floatList.splice(index,1, data)
    },
    clearFloatList:(state) =>{
      state.floatList = []
      state.floatzIndex = 9999
    }
  },

  actions: {

  }
}

export default float